import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Account from "app/pages/Account/Account";
import { logout as logoutAction } from "app/pages/Auth/AuthActions";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import { useCallback, useEffect } from "react";
import { brandPropTypes } from "app/utils/propTypes";
import { fetchSearchMyBookingNotification as fetchSearchMyBookingNotificationAction } from "app/pages/Account/SearchMyBooking/searchMyBookingActionCreators";
import { useInvalidateMyBookingsNotification } from "app/features/myBookings";

const mapStateToProps = state => ({
	isAuthenticated: isAuthenticated(state),
	brand: state.brand.code,
	shop: state.shop,
	email: state.email,
	enableSponsorship: state.partner.enableSponsorship,
	searchMyBooking: state.searchMyBooking,
});

const AccountContainer = () => {
	const {
		isAuthenticated: isAuthenticatedState = false,
		brand,
		enableSponsorship = false,
		shop,
		email,
		searchMyBooking = {},
	} = useSelector(mapStateToProps, shallowEqual);

	const dispatch = useDispatch();
	const logout = useCallback(() => dispatch(logoutAction()), [dispatch]);
	const invalidateMyBookingsNotification = useInvalidateMyBookingsNotification();
	const fetchSearchMyBookingNotification = useCallback(
		(...args) => dispatch(fetchSearchMyBookingNotificationAction(...args)),
		[dispatch]
	);

	const navigate = useNavigate();

	const onLogout = useCallback(() => {
		logout();
		navigate({ pathname: "/" });
	}, []);

	useEffect(() => {
		if (isAuthenticatedState) {
			invalidateMyBookingsNotification();
		} else if (searchMyBooking?.booking?.bookingReference) {
			fetchSearchMyBookingNotification({
				brand,
				shop,
				email,
				bookingReference: searchMyBooking?.booking?.bookingReference,
			});
		}
	}, [isAuthenticatedState]);

	return (
		<Account
			onLogout={onLogout}
			enableSponsorship={enableSponsorship}
			brand={brand}
			isAuthenticated={isAuthenticatedState}
		/>
	);
};

AccountContainer.propTypes = {
	logout: PropTypes.func,
	enableSponsorship: PropTypes.bool,
	brand: brandPropTypes,
	isAuthenticated: PropTypes.bool,
	email: PropTypes.string,
	shop: PropTypes.string,
	searchMyBooking: PropTypes.object,
	fetchSearchMyBookingNotification: PropTypes.func,
};

export default AccountContainer;
